var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.lote.status === _vm.statusVendido && _vm.getArremate && _vm.getArremate.status && Number(_vm.getArremate.status) !== 2)?_c('status-pagamento-lote',{attrs:{"pagamento":{status: 0}}}):_c('status-lote-selector',{staticClass:"no-select",attrs:{"status":_vm.lote.status}})
}
var staticRenderFns = []

export { render, staticRenderFns }